import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSpinner } from '@angular/material/progress-spinner';
import { MatSnackBar } from '@angular/material/snack-bar';
import { validationmethod } from '../../../shared/common/validationmethod';
import { LocalStorageSettingsService } from '../../../shared/services/local-storage-settings.service';
import { CommonService } from '../../../shared/services/common.service';
import { ErrorMessages } from '../../../shared/common/errormessages';
import { AsignUserRoleService } from '../../../shared/services/asign-user-role.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { constants } from '../../../shared/common/contants';
import * as CryptoJS from 'crypto-js';
import { Deletebutton } from 'src/app/shared/common/Deletebutton';
export interface checkinListDialogData {
  edata: any;
  page: any;
  columns: any;
  remarksData: any;
  childId: any;
}

@Component({
    selector: 'app-awssecretpopup',
    templateUrl: './awssecretpopup.component.html',
    styleUrls: ['./awssecretpopup.component.scss'],
    standalone: false
})
export class AwssecretpopupComponent implements OnInit {
  gridAPI;
gridReadParam;
gridColumnAPI;
lastPage;
currentPage;
nextPage;
nextPagePlusOne;
totalPages;
gridColumnAPIDispatch;
columnDefs;
rowData;
rowClassRules;
defaultColDef;
rowSelection;
paginationPageSize;
paginationNumberFormatter;
pageSize;
components;
gridOptions

  FormValid: FormGroup = new FormGroup({});
  isupdate:boolean=false;
  iskeyshow:boolean=false;

  validation_messages: any;
  backgroundColorButton = '';
  userRoleNameData: any;
  bpCompnayId: any;
  userrolesmstrid: '';
  usersData: any;
  keyValueObj = {
  'key':'',
  'value':''
}
  secretObj = {
    'dnsId': '',
    'secretName':'',
    'region': '',
    'values':[],
  };

  userid: '';
  buttonName: any;
  materialData: any;
  isroleassigned: any;
  keyValueFormValid: FormGroup;
  showTable=false;
  originalPassword: string = '';  // To store original password value
  selectedDns: any; 
  dnsnames: any[] = [];
  name: string = '';
  defaultLoginDns: any;
  tableName: string = "objectmetadata";
  constructor(
    public dialogref: MatDialogRef<AwssecretpopupComponent>,
    private validation: validationmethod,
    private localStorageSettings: LocalStorageSettingsService,
    private commonservice: CommonService,
    private commonService: CommonService,
    private errorMsg: ErrorMessages,
    private asignUserRoleService: AsignUserRoleService,
    private spinner: NgxUiLoaderService,
    private snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: checkinListDialogData,
    private constants: constants,
  ) {
    this.validation_messages = this.errorMsg.concreteUpdateReportMessages;
     //messages for validations(DNS name, Secret Name, Region)
    this.validation_messages = this.errorMsg.awsSecretPopup;
    this.components = {
      buttonRenderer: Deletebutton,
    };
  }


  ngOnInit() {
    this.columnDefs = [
      {
        headerName: 'Action',
        filter: false,
        cellRenderer: 'buttonRenderer',
        cellRendererParams: {
          delete: this.deleteIcon.bind(this)

        },
        pinned: 'left',
        lockPinned: true,
        width: 90,
      },

      {
        headerName: 'Key',
        headerTooltip: 'Key',
        tooltipValueGetter: (params) =>
          'key: ' + params.value,
        field: 'key',
        filter: 'agTextColumnFilter',
        width: 280,
        editable: false,
      }
      ,
      {
        headerName: 'value',
        headerTooltip: 'value',
        tooltipValueGetter: (params) =>
          'value: ' + params.value,
        field: 'value',
        filter: 'agTextColumnFilter',
        width: 390,
        editable: true,
      }
     ]
    this.formvalidations();
    console.log(this.data.edata.dnsId)

    if (this.data.edata.dnsId != undefined) {
      this.secretObj = {
        'dnsId': this.data.edata.dnsId,
        'secretName':this.data.edata.secretName,
        'region': this.data.edata.region,
        'values':this.data.edata.values
         
      };
       console.log(this.secretObj)
       this.retriveDns({ value: this.data.edata.dnsId, });
      // this.secretObj.dnsId = this.data.edata.dnsId
      //  for (let i = this.secretObj.values.length - 1; i >= 0; i--) {
      //   if (this.secretObj.values[i].key.toLowerCase() === "password") {
      //     this.keyValueObj = {
      //       'key':'password',
      //       'value':''
      //     }
      //     this.iskeyshow=true;
      //     this.secretObj.values.splice(i, 1);
      //   }
      // }

      this.FormValid.get('dnsId').disable();
      this.FormValid.get('secretName').disable();
      this.FormValid.get('region').disable();
      this.buttonName = 'Update';
      // this.retriveDns(this.secretObj.dnsId)
      console.log(this.secretObj.values.length);
      if(this.secretObj.values.length>0){
        this.showTable=true;
      }
      this.isupdate=true;
    } else {
      this.buttonName = 'Save';

    }
    this.Dropdown();

    this.backgroundColorButton = this.localStorageSettings.getSettings('ColorA');
    console.log(this.backgroundColorButton);


  }

  formvalidations() {
    this.FormValid = new FormGroup({
      dnsId: new FormControl(this.secretObj.dnsId|| '', [Validators.required, this.validation.noWhitespaceValidator]),
      secretName: new FormControl(this.secretObj.secretName, [Validators.required, this.validation.noWhitespaceValidator]),
      region: new FormControl(this.secretObj.region, [Validators.required, this.validation.noWhitespaceValidator])
    });
    console.log('Form Validations:', this.FormValid.value);

  }


/*
  async Dropdown() {
    var tenantId = this.localStorageSettings.getSettings('dnsName');
    //retrieving users by dnsId
    this.spinner.start();
    this.commonService.retrieveDnsService(tenantId).subscribe((response) => {
      console.log(response);

      if (response.error == true) {
        this.spinner.stop();
        this.snackBar.open(response.statusMessage, 'OK', { duration: 5000 });
        return null;
      } else {
        this.spinner.stop();
        this.userRoleNameData = response;
        console.log(this.userRoleNameData)
      }
    });


  }
    */
  async Dropdown() {
    const defaultVaultId = +localStorage.getItem("defaultVaultId");
    const vaultIds = JSON.parse(localStorage.getItem("vaultIds"));
    
    this.dnsnames = []; // Clear array to avoid duplication
  
    for (let i = 0; i < vaultIds.length; i++) {
      if (vaultIds[i].id === defaultVaultId) {
        this.name = vaultIds[i].target;
        this.defaultLoginDns = vaultIds[i];
        this.localStorageSettings.saveSettings("SelectedDnsName", vaultIds[i].name);
  
        if (this.tableName === "objectmetadata") {
          const sourceObj = {
            id: vaultIds[i].sourceDnsId,
            name: vaultIds[i].source,
            url: vaultIds[i].url
          };
  
          const targetObj = {
            id: vaultIds[i].targetDnsId,
            name: vaultIds[i].target,
            url: vaultIds[i].url
          };
  
          this.dnsnames.push(targetObj);
          this.dnsnames.push(sourceObj);
        } else {
          this.dnsnames.push(vaultIds[i]);
        }
      }
      
    }
  
    console.log("DNS Names: ", this.dnsnames);
    console.log("secretObj", this.secretObj);
  
    // If additional call is needed to fetch user roles based on DNS
    const tenantId = this.localStorageSettings.getSettings('dnsName');
    this.spinner.start();
    this.commonService.retrieveDnsService(tenantId).subscribe((response) => {
      this.spinner.stop();
  
      if (response.error) {
        this.snackBar.open(response.statusMessage, 'OK', { duration: 5000 });
        return;
      }
  
      this.userRoleNameData = response;
      console.log(this.userRoleNameData);
    });
  }
  

  async retriveDns(event) {
    console.log(event);
    this.secretObj.dnsId = event.value
    console.log("This is dnsid"+this.secretObj.dnsId)
    console.log("Updated secretObj:", this.secretObj);  // Ensure dnsId is set
    console.log(this.secretObj)
    /*
    Modified by Shyam
    18-10-2024
    Implemented to get the region name, secret name and key value pairs based on selected DnsID
    */
    try {
      const response = await this.commonService.retrieveDnsServicesforRegionandsecret(this.secretObj.dnsId).toPromise();
      console.log("API Response: ", response);
      
      if (response.error) {
          this.snackBar.open(response.statusMessage, 'OK', { duration: 5000 });
      } else {
          this.secretObj.secretName = response.secretName; 
          this.secretObj.region = response.regionName;
          this.secretObj.values = Object.entries(response.secretDetails).map(([key, value]) => ({
            key: key,
            value: value
        })) || [];
          console.log(this.secretObj)
          this.originalPassword = this.getOriginalPassword(this.secretObj.values);
          this.FormValid.get('secretName').setValue( this.secretObj.secretName);
          this.FormValid.get('region').setValue(this.secretObj.region);
          this.FormValid.get("dnsId").setValue(this.secretObj.dnsId)
          console.log(this.FormValid)
          this.updateGridData();
      }
  } catch (error) {
        console.error("Error fetching DNS services: ", error);
        this.snackBar.open("Failed to retrieve DNS services. Incorrect Secret Name or Region", 'OK', { duration: 5000 });
    }
   
  }
//   updateFormFields() {
//     this.FormValid.get('secretName').reset();
//     this.FormValid.get('region').reset();
//     // this.FormValid.get('secretName').setValue(this.secretObj.secretName);
//     // this.FormValid.get('region').setValue(this.secretObj.region);
// }

  async updateData() {
    if(this.secretObj.secretName==""||this.secretObj.region==""||this.secretObj.dnsId==""){
      this.validation.validateAllFormFields(this.FormValid);
      this.validation.getvalidationmessage();
      this.snackBar.open("All mandatory fields to be filled", 'OK', { duration: 5000 });
      return;
    }
    if(this.secretObj.values.length<=0){
      this.snackBar.open("Please enter atleast one key-value pair", 'OK', { duration: 5000 });
      return;
    }
    if (this.keyValueObj.key !=='') {
      this.snackBar.open("Please select value for keys", 'OK', { duration: 5000 });
      return;
    }
   let dto=this.transformInputToOutput(this.secretObj);
   console.log('Sending data:', dto);  // Log the dto object
   console.log(dto.secretName, dto.region);
    this.commonService.saveAwsSecret(dto,this.secretObj.dnsId,this.buttonName).subscribe(response => {
      if (response.error == true) {
        console.log('inside error');
        console.log(response);
        this.spinner.stop();
        this.dialogref.close();
        this.snackBar.open(response.statusMessage, 'OK', {duration: 5000});

      } else {

        this.spinner.stop();
        this.dialogref.close();
        this.snackBar.open(response.statusMessage, 'OK', {duration: 50000});
      }
    });


    console.log(this.buttonName)
  }

  close() {
    this.dialogref.close();
  }

  addRecord() {
    if (this.keyValueObj.key === '' || this.keyValueObj.value === '') {
      this.snackBar.open("Key and Value can not be empty", 'OK', { duration: 5000 });
      return;
    }

    // Check if the key already exists in this.secretObj.values
    if (this.secretObj.values.some(item => item.key === this.keyValueObj.key)) {
      // Key already exists, show an error message or handle it as needed
      this.snackBar.open("Key already exists", 'OK', { duration: 5000 });
      return;
    }

    let tempkeyvalueobj = Object.assign({}, this.keyValueObj); // Creates a shallow copy
    this.secretObj.values.push(tempkeyvalueobj);
    console.log(this.secretObj.values);


    this.keyValueObj = {
      'key': '',
      'value': ''
    }
    if (this.iskeyshow) {
      this.iskeyshow = false;
    }
   this. updateGridData();

    console.log(this.secretObj);
  }


deleteWhere(k){
  console.log(k)
  const index = this.secretObj.values.findIndex(pair => pair.key === k.key);
  console.log(index)
 if(index !== -1){
  this.secretObj.values.splice(index,1);
  console.log(this.secretObj.values)
  if(this.secretObj.values.length==0){
    this.showTable=false
  }
  console.log(this.secretObj.values)
  this.updateGridData();
 }

}
// In a method where you want to update the grid data
updateGridData() {
  // Ensure that this.gridAPI is defined
  if (this.gridAPI) {
    this.gridAPI.setGridOption('rowData', this.secretObj.values);
  } else {
    console.error("Grid API is not available. Make sure the grid is initialized.");
  }
}


transformInputToOutput(input: {
  dnsId: string;
  secretName: string;
  region: string;
  values: Array<{ key: string; value: string }>;
}): {
  secretName: string;
  secretKeyValue: { [key: string]: string };
  region: string;
} {
  const output = {
    secretName: input.secretName,
    secretKeyValue: {} as { [key: string]: string },
    region: input.region,
  };

  for (const item of input.values) {
    if (item.key === "password") {
      if (item.value === this.originalPassword) {
        // Password is the same, use the original value without re-encryption
        output.secretKeyValue[item.key] = this.originalPassword;
      } else {
        // Password has changed, encrypt the new password
        output.secretKeyValue[item.key] = this.encrpt("123456$#@$^@1ERF", item.value).toString();
      }
    } else {
      output.secretKeyValue[item.key] = item.value;
    }
  }

  return output;
}
encrptKey = "123456$#@$^@1ERF";
encrpt(keys, value) {


    var encrypted = CryptoJS.AES.encrypt(value, this.encrptKey);
encrypted = encrypted.toString();
console.log("Cipher text: " + encrypted);

  console.log(encrypted);

  return encrypted.toString();

}


onGridReady(params) {
  this.gridReadParam = params
  this.gridAPI = params.api;
  this.gridColumnAPI = params.columnApi;
  this.scheduleData();

}
scheduleData() {
  this.gridAPI.setGridOption('rowData', this.secretObj.values);


}
onPaginationChangedReturn() {
  if (this.gridAPI) {
    this.lastPage = this.gridAPI.paginationIsLastPageFound();
    this.currentPage = this.gridAPI.paginationGetCurrentPage() + 1;
    this.nextPage = this.gridAPI.paginationGetCurrentPage() + 1 + 1;
    this.nextPagePlusOne =
      this.gridAPI.paginationGetCurrentPage() + 1 + 1 + 1;
    this.totalPages = this.gridAPI.paginationGetTotalPages();
  }
}

// below function is for changing the no of rows per page
onPageSizeChanged() {
  console.log('Return page size');
  let value = this.pageSize;
  this.gridAPI.setGridOption('paginationPageSize', Number(value));
}

// below function is for going to next page
onBtNext() {
  console.log('next');
  this.gridAPI.paginationGoToNextPage();
}

// below function for going to previous page
onBtPrevious() {
  console.log('previous');
  this.gridAPI.paginationGoToPreviousPage();
}

// below function for going to first page
onBtFirst() {
  this.gridAPI.paginationGoToFirstPage();
}

// below function for going to last page
onBtLast() {
  this.gridAPI.paginationGoToLastPage();
}

//excel export function
onBtExport() {
  this.gridAPI.exportDataAsCsv();
}

onSearchChange(searchValue: number) {
  this.gridAPI.paginationGoToPage(searchValue - 1);
}
async deleteIcon(e) {
  this.deleteWhere(e.rowData);

    }
    
onDnsIdChange(event) {
  console.log(this.selectedDns)
  const selectedDnsId = event.target.value;
  console.log("Selected DNS ID:", selectedDnsId);
  this.retriveDns({ value: selectedDnsId });
}
// to get the password from aws secret which encrypted
getOriginalPassword(values: Array<{ key: string; value: string }>): string {
  const passwordEntry = values.find(item => item.key.toLowerCase() === 'password');
  return passwordEntry ? passwordEntry.value : '';
}

}
